module.exports = {"fb_lang":"zh_TW","mapCenter":{"lat":"25.0172264","lng":"121.506378"},"geocomplete_country":"tw","PHONE_REGEX":"^\\d{10}$","EMAIL_REGEX":"^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}","zh-TW":{"blank_field":"請填寫這個欄位。","incorrect_email":"請填寫正確電郵。","error_message_signup_email_used":"電郵 已登記","error_message_signup_phone_taken":"電話號碼 已登記"}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/src/tw/scripts/components/setting.json
// module id = 858
// module chunks = 0 1 2 3 4 5